import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';
import { useNavigate } from '@utils/hooks';

import Wallets from '@containers/Wallets';
import MainLayout from '@layouts/MainLayout';

import style from './WalletsDetails.scss';

const cn = bemCssModules(style, 'WalletsDetails');
const ti = getTestId('WalletsDetails');

export const WalletsDetails: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <MainLayout backButton={() => navigate(CONST.nav.wallets)}>
      <div className={cn(null, [className])} data-testid={ti()}>
        <h2 className={cn('title')}>{t('menu.wallets')}</h2>
        <Wallets isDetailPage />
      </div>
    </MainLayout>
  );
};

export default WalletsDetails;
